import React from 'react'

export const PremiumBadge = ({ prevPrice = 0, newPrice = 0 }) => {
    return (
        <div className="flex px-2 py-1 bg-premium-badge-pattern rounded-xl items-center">
            <i aria-hidden className="fak fa-premium-badge text-sm text-white"></i>
            <div className="mr-1" />
            <div className="flex">
                <p className="text-white text-opacity-60 font-normal text-xs line-through mr-[2px]">
                    ${prevPrice}
                </p>
                <p className="text-white text-xs">${newPrice} PREMIUM</p>
            </div>
        </div>
    )
}
